import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Instagram } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-foreground text-primary-foreground">
      <div className="container section-padding">
        <div className="grid md:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <img src="/amparo_logo.png" alt="Amparo & Aconchego" className="h-10 w-auto object-contain brightness-0 invert" loading="lazy" decoding="async" />
            </div>
            <p className="text-sm text-primary-foreground/90 leading-relaxed">
              Cuidado humanizado para idosos no Rio de Janeiro. Transparência, respeito e carinho em cada atendimento.
            </p>
          </div>

          {/* Links */}
          <div>
            <h3 className="font-display font-semibold text-sm mb-4 uppercase tracking-wider text-primary-foreground">Navegação</h3>
            <ul className="space-y-2 text-sm">
              {[
                { label: "Serviços", path: "/servicos" },
                { label: "Como Funciona", path: "/como-funciona" },
                { label: "Sobre Nós", path: "/sobre" },
                { label: "Para Famílias", path: "/para-familias" },
                { label: "Trabalhe Conosco", path: "/trabalhe-conosco" },
              ].map((l) => (
                <li key={l.path}>
                  <Link to={l.path} className="text-primary-foreground/90 hover:text-primary-foreground transition-colors">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-display font-semibold text-sm mb-4 uppercase tracking-wider text-primary-foreground">Contato</h3>
            <ul className="space-y-3 text-sm text-primary-foreground/90">
              <li className="flex items-center gap-2">
                <Phone className="h-4 w-4 text-accent" />
                <a href="tel:+5521974615899" className="hover:text-primary-foreground">(21) 97461-5899</a>
              </li>
              <li className="flex items-center gap-2">
                <Mail className="h-4 w-4 text-accent" />
                <a href="mailto:amparoeaconchego@gmail.com" className="hover:text-primary-foreground">amparoeaconchego@gmail.com</a>
              </li>
              <li className="flex items-center gap-2">
                <MapPin className="h-4 w-4 text-accent" />
                <span>Rio de Janeiro, RJ</span>
              </li>
              <li className="flex items-center gap-2">
                <Instagram className="h-4 w-4 text-accent" />
                <a href="https://instagram.com/amparoeaconchego" target="_blank" rel="noopener noreferrer" className="hover:text-primary-foreground">@amparoeaconchego</a>
              </li>
              <li className="flex items-center gap-2">
                <Phone className="h-4 w-4 text-accent" />
                <a href="tel:+5521991233553" className="hover:text-primary-foreground">(21) 99123-3553</a>
              </li>
              <li className="flex items-center gap-2">
                <Phone className="h-4 w-4 text-accent" />
                <a href="tel:+5521983761879" className="hover:text-primary-foreground">(21) 98376-1879</a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="font-display font-semibold text-sm mb-4 uppercase tracking-wider text-primary-foreground">Legal</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/privacidade" className="text-primary-foreground/90 hover:text-primary-foreground transition-colors">
                  Política de Privacidade
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-primary-foreground/10 mt-10 pt-6 text-center text-xs text-primary-foreground/75">
          © {new Date().getFullYear()} Amparo & Aconchego. Todos os direitos reservados.
        </div>
        <div className="text-center text-xs text-primary-foreground/75">
          {/*<!-- Backlinks never hurt anyone -->*/}

          Site construído com ❤️ por <a href="https://huntermussel.com/" target="_blank" rel="noopener noreferrer" className="text-primary-foreground hover:text-primary-foreground/90 transition-colors">HunterMussel.com</a>
        </div>
      </div>
    </footer>
  );
}
